import { Responsible } from './context/responsible/entity';

export const responsibleList: Responsible[] = [
    Responsible.new({
        name: 'Asset Owner',
        description:
            'The individual or organization that owns the assets (hardware, software, and data) within the industrial control system. They are responsible for defining security requirements and ensuring that the system meets those requirements.',
    }),
    Responsible.new({
        name: 'System Integrator',
        description:
            'The entity responsible for integrating various components of the IACS, including hardware and software. They ensure that the system is designed and implemented according to the security requirements set by the asset owner.',
    }),
    Responsible.new({
        name: 'Product Supplier',
        description:
            'The organization that develops and supplies the hardware and software components used in the IACS. They are responsible for ensuring that their products meet security standards and are designed with security features.',
    }),
    Responsible.new({
        name: 'Security Manager',
        description:
            'This role involves overseeing the security policies and practices within the organization. The security manager is responsible for implementing and maintaining the security program, ensuring compliance with relevant standards, and managing security incidents.',
    }),
    Responsible.new({
        name: 'Security Analyst',
        description:
            'A professional who analyzes security risks and vulnerabilities within the IACS. They conduct assessments, monitor security events, and provide recommendations for improving security posture.',
    }),
    Responsible.new({
        name: 'Maintenance Personnel',
        description:
            'Individuals responsible for the ongoing maintenance and support of the IACS. They must be aware of security practices and ensure that maintenance activities do not compromise the security of the system.',
    }),
    Responsible.new({
        name: 'Regulatory Authority',
        description:
            'An external entity that establishes regulations and standards for the security of industrial control systems. They may conduct audits and assessments to ensure compliance with security requirements.',
    }),
];
